import { MappedClass, MappedProperty } from '@h5s/util-object';
import { ZPrinterDgfeStatusNullable } from './z-printer-dgfe-status-nullable';
import { ZPrinterRtStatusNullable } from './z-printer-rt-status-nullable';

@MappedClass()
export class ZPrinterFullStatus {
  @MappedProperty()
  connection_status_code: string | null;

  @MappedProperty()
  connection_status_message: string | null;

  @MappedProperty()
  cover_open: boolean;

  @MappedProperty()
  date_time: string | null;

  @MappedProperty()
  dgfe_free_space: number | null;

  @MappedProperty()
  dgfe_status: ZPrinterDgfeStatusNullable | null;

  @MappedProperty()
  first_pending_file_date_time: string | null;

  @MappedProperty()
  fw_version: string | null;

  @MappedProperty()
  in_service: boolean;

  @MappedProperty()
  in_service_date: string | null;

  @MappedProperty()
  inactive: boolean;

  @MappedProperty()
  is_day_open: boolean;

  @MappedProperty()
  is_mf: boolean;

  @MappedProperty()
  is_printer_supported: boolean;

  @MappedProperty()
  is_server_connected: boolean;

  @MappedProperty()
  last_fiscal_document_number: number | null;

  @MappedProperty()
  lottery_enabled_on_next_document: boolean;

  @MappedProperty()
  lottery_number_of_suspended_document: number;

  @MappedProperty()
  paper_over: boolean;

  @MappedProperty()
  pending_files: number;

  @MappedProperty()
  rt_status: ZPrinterRtStatusNullable | null;

  @MappedProperty()
  serial_number: string | null;

  @MappedProperty()
  server_status_code: string | null;

  @MappedProperty()
  total_zeroing_number: number | null;

  @MappedProperty()
  vat_table: string | null;
}
